// extracted by mini-css-extract-plugin
export default {"strong":"Strong_strong__j7kKH"};